'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
const components_marketing_CTA_CTATextContent = require('../CTATextContent.cjs.js');
const components_marketing_CTA_utils = require('../utils.cjs.js');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');
const styleMixins_reset = require('../../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("CTAFilled", {
  root: (backgroundColor, maxWidth = 1170) => react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 20px;
    padding: 40px 30px;
    border-radius: 10px;
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};

    @media screen and (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      margin: 40px 30px;
      padding: 40px;
    }

    @media screen and (min-width: 1230px) {
      margin: 40px auto;
      padding: 40px 70px;
    }
  `,
  mediaContent: react.css`
    ${styleMixins_reset.boxSizing};
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `
});
const CTAFilled = ({ backgroundColor = "neutral100", children, ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth, onCtaClick, onCtaKeyDown, subHeading, ctaTarget }) => {
  const bgColor = components_marketing_CTA_utils.getBgColor(backgroundColor);
  return react.jsx(
    "div",
    { css: Styles.root(bgColor, maxWidth), "data-zds": true },
    react.jsx(components_marketing_CTA_CTATextContent.CTATextContent, { heading, subHeading, description, ctaText, ctaHref, ctaBtnColor, onCtaClick, onCtaKeyDown, bgColor, ctaTarget }),
    react.jsx("div", { css: Styles.mediaContent, "data-testid": "media-content", "data-zds": true }, children)
  );
};

exports.CTAFilled = CTAFilled;
//# sourceMappingURL=CTAFilled.cjs.js.map
